import { render, staticRenderFns } from "./controlpoint.vue?vue&type=template&id=c8e5925c&scoped=true&"
import script from "./controlpoint.vue?vue&type=script&lang=js&"
export * from "./controlpoint.vue?vue&type=script&lang=js&"
import style0 from "./controlpoint.vue?vue&type=style&index=0&id=c8e5925c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e5925c",
  null
  
)

export default component.exports